import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jkwarag9fz: FaireBrandEntity = {
  token: "b_jkwarag9fz",
  type: "brand",
  name: "Headwaters BBQ",
  avatarUrl:
    "https://cdn.faire.com/fastly/c191e8739cdaee1696aac95cba681579f32b9446a490b0c31d0343d4a11ae871.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c39b6bfeee7a75cea6c2601a2fc9eae44d88e7c28bb6afc0285ba1e7b5158d79.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c191e8739cdaee1696aac95cba681579f32b9446a490b0c31d0343d4a11ae871.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c39b6bfeee7a75cea6c2601a2fc9eae44d88e7c28bb6afc0285ba1e7b5158d79.png",
  location: "Bozeman, MT, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 8,
  isInsider: true,
  description:
    "It started as a school entrepreneurship project with my 10 and 14 year old boys, selling a sauces at the local farmers market.  Years later, we've added new items, and are now in  many grocery, specialty, and retail stores.\nWe're a family operation.  We make, mix, fill, wash, label, and box it all up ourselves.\nWe are involved in our communities, going to festivals, events, and helping youth and charities.\nOh yes, we love to grill and bbq too!",
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:34.496Z",
    importedBy: "entity-db-cli",
  },
};
